import { useEffect, useState } from "react";
import { Zap, ShieldCheck, GraduationCap } from "lucide-react";

const BANNERS = [
  "Trasforma il tuo corpo con un metodo, non con la fortuna",
  "Niente schede copia-incolla: il tuo piano è solo tuo",
  "Allenamento + alimentazione + integrazione: un unico percorso",
  "Inizia oggi: la tua scheda è attiva subito dopo l'acquisto",
];

const BADGES = [
  { icon: Zap, color: "#a020f0", title: "Accesso Immediato", sub: "Scheda attiva subito su app dedicata" },
  { icon: ShieldCheck, color: "#38bdf8", title: "Checkout Stripe", sub: "Pagamenti sicuri e crittografati" },
  { icon: GraduationCap, color: "#c084fc", title: "Scienze Motorie", sub: "Supporto tecnico scientifico continuo" },
];

export const Hero = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % BANNERS.length), 4000);
    return () => clearInterval(t);
  }, []);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <header id="hero" data-testid="hero-section" className="relative pt-16 pb-24 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {/* Rotating promo badge */}
        <div data-testid="hero-promo-badge" className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full bg-[#1e1038] border border-[#a020f0]/40 text-xs text-[#d8b4fe] mb-8 d1-fade">
          <span className="w-2 h-2 rounded-full bg-[#38bdf8] animate-ping"></span>
          <span className="font-medium">Focus. Metodo. Costanza.</span>
          <span className="text-[#64748b]">|</span>
          <span className="text-white font-semibold">Ricomposizione Corporea &amp; Bodybuilding</span>
        </div>

        <h1 className="display-font text-5xl md:text-8xl uppercase leading-[0.92] text-white tracking-tight mb-8">
          <span className="ln"><span>RAGGIUNGI IL TUO</span></span>
          <span className="ln"><span className="text-transparent bg-clip-text bg-gradient-to-r from-[#a020f0] via-[#c084fc] to-[#38bdf8]">MASSIMO POTENZIALE</span></span>
          <span className="ln"><span>FISICO CONCRETO</span></span>
        </h1>

        <p className="text-lg md:text-xl text-[#cbd5e1] max-w-2xl mb-6 leading-relaxed d1-fade">
          Percorsi 100% personalizzati di allenamento, alimentazione e integrazione guidati da un chinesiologo specializzato.
        </p>

        {/* Rotating purchase-incentive banner */}
        <div className="max-w-2xl mb-10 d1-fade" data-testid="hero-rotating-banner">
          <p key={idx} className="hero-banner-fade text-sm md:text-base font-semibold text-[#d8b4fe] border-l-2 border-[#a020f0] pl-4">
            {BANNERS[idx]}
          </p>
          <div className="flex gap-1.5 mt-3 pl-4">
            {BANNERS.map((_, i) => (
              <button key={i} data-testid={`hero-banner-dot-${i}`} onClick={() => setIdx(i)} aria-label={`Frase ${i + 1}`}
                className={`h-1.5 rounded-full transition-[width,background-color] ${i === idx ? "w-6 bg-[#a020f0]" : "w-2 bg-[#3b2364]"}`} />
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 mb-16 d1-fade">
          <button data-testid="hero-cta-inizia" onClick={() => scrollTo("pacchetti")}
            className="px-8 py-4 rounded-xl bg-gradient-to-r from-[#6a0dad] to-[#a020f0] text-white font-bold text-center text-sm uppercase tracking-wider hover:scale-[1.02] shadow-xl shadow-[#6a0dad]/50 transition-[transform,box-shadow]">
            Inizia Ora • Da 89€
          </button>
          <button data-testid="hero-cta-metodo" onClick={() => scrollTo("metodo")}
            className="px-8 py-4 rounded-xl bg-[#1a0f2e] border border-[#3b2364] text-white font-bold text-center text-sm uppercase tracking-wider hover:bg-[#251542] transition-colors">
            Scopri il Metodo
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-8 border-t border-[#23153d]">
          {BADGES.map(({ icon: Icon, color, title, sub }) => (
            <div key={title} data-testid={`trust-badge-${title.toLowerCase().replace(/\s/g, "-")}`}
              className="flex items-center gap-4 p-4 rounded-xl bg-[#140b24] border border-[#2d1b4e]">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}33`, color }}>
                <Icon className="w-5 h-5" />
              </div>
              <div>
                <div className="text-sm font-bold text-white uppercase tracking-wider">{title}</div>
                <div className="text-xs text-[#94a3b8]">{sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};
